// extracted by mini-css-extract-plugin
export var arrowNextStyle = "carousel_control_arrow-module--arrowNextStyle--7byXv";
export var arrowPreviousStyle = "carousel_control_arrow-module--arrowPreviousStyle--evrwP";